import { setRequestErrored, setRequestInProcess } from 'actions/request';
import { fetchAccountInfo } from 'actions/user';
import { PoliciesAction, RequestAction } from 'constants/actions';
import { APIResponseError } from 'models/error';
import { hasAutomatedCancelProcess } from 'models/insurances/types/mapping';
import { OptionalPolicyAttributes, Policy } from 'models/policies';
import { AppState } from 'reducers';
import { ThunkDispatch } from 'redux-thunk';
import endpoint from 'shared/api';

type UnknownObject = Record<string, unknown>;

export type MergeRequestAction = RequestAction | PoliciesAction;

export function mergePolicyDetail(item: Policy) {
  return {
    type: 'ME_MERGE_POLICY_DETAIL' as const,
    item,
  };
}

export function mergePolicyAttr(
  policyId: string,
  attr: OptionalPolicyAttributes
) {
  return {
    type: 'ME_MERGE_POLICY_ATTR' as const,
    policyId,
    attr,
  };
}

// TODO: replace with useGetPolicy invalidation
export function fetchPolicyDetail(policyId: string) {
  return async (
    dispatch: ThunkDispatch<AppState, UnknownObject, MergeRequestAction>
  ) => {
    const requestType = 'LOAD_MY_POLICY_DETAIL';

    dispatch(setRequestInProcess(true, requestType));

    try {
      const { data } = await endpoint.getPolicyDetail(policyId);
      await dispatch(fetchAccountInfo());
      dispatch(mergePolicyDetail(data));
      dispatch(setRequestInProcess(false, requestType));
      if (hasAutomatedCancelProcess[data.type] && data.status !== 'CANCELED') {
        dispatch(fetchPolicyCancellation(policyId));
      }
    } catch (error) {
      dispatch(setRequestErrored(error as APIResponseError, requestType));
    }
  };
}

export function fetchPolicyCancellation(policyId: string) {
  return async (
    dispatch: ThunkDispatch<AppState, UnknownObject, MergeRequestAction>
  ) => {
    const requestType = 'LOAD_MY_POLICY_CANCELLATION';
    dispatch(setRequestInProcess(true, requestType));

    try {
      const { data } = await endpoint.getPolicyCancellation(policyId);
      dispatch(mergePolicyAttr(policyId, data));
      dispatch(setRequestInProcess(false, requestType));
    } catch (error) {
      dispatch(setRequestErrored(error as APIResponseError, requestType));
    }
  };
}
